
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/archive/cover",
      function () {
        return require("private-next-pages/archive/cover.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/archive/cover"])
      });
    }
  